import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../helpers/AuthContext';

export default function SellerNavChannelSwitcher() {
  const { channel, fetch } = useAuth();
  const [switcherData, setSwitcherData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const loadSwitcherData = async () => {
      setLoading(true);
      try {
        const response = await fetch('/account/switcher.json');
        const data = await response.json();
        setSwitcherData(data);
      } catch (err) {
        console.error('Failed to load channel switcher data:', err);
        setSwitcherData({ owned: [], admin: [], currentChannelId: channel?.id });
      } finally {
        setLoading(false);
      }
    };

    loadSwitcherData();
  }, [isOpen, fetch, channel?.id]);

  if (!channel) return null;

  const hasOtherChannels =
    (switcherData?.owned?.length || 0) > 1 || (switcherData?.admin?.length || 0) > 0;

  return (
    <div className="seller-nav-sidebar__channel-switcher">
      <button
        type="button"
        className="seller-nav-sidebar__channel-switcher-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="seller-nav-sidebar__channel-switcher-current">
          <span className="seller-nav-sidebar__channel-switcher-avatar" aria-hidden="true">
            <i className="fa-solid fa-store"></i>
          </span>
          <span className="seller-nav-sidebar__channel-switcher-name">
            {channel.basics?.title || channel.slug || 'Your Channel'}
          </span>
        </span>
        <span className="seller-nav-sidebar__channel-switcher-arrow" aria-hidden="true">
          <i className="fa-solid fa-chevron-down"></i>
        </span>
      </button>

      {isOpen && (
        <div className="seller-nav-sidebar__channel-switcher-panel">
          {loading ? (
            <div className="seller-nav-sidebar__channel-switcher-loading">Loading channels...</div>
          ) : !hasOtherChannels ? (
            <div className="seller-nav-sidebar__channel-switcher-empty">
              You have no other channels to switch to.
            </div>
          ) : (
            <>
              {switcherData?.owned && switcherData.owned.length > 1 && (
                <>
                  <div className="seller-nav-sidebar__channel-switcher-group-label">Owned</div>
                  <ul className="seller-nav-sidebar__channel-switcher-list">
                    {switcherData.owned.map(ch => (
                      <li key={ch.uuid}>
                        <a href={`/account/switcher/${ch.uuid}`}>{ch.basics?.title || ch.slug}</a>
                      </li>
                    ))}
                  </ul>
                </>
              )}
              {switcherData?.admin && switcherData.admin.length > 0 && (
                <>
                  <div className="seller-nav-sidebar__channel-switcher-group-label">Admin</div>
                  <ul className="seller-nav-sidebar__channel-switcher-list">
                    {switcherData.admin.map(ch => (
                      <li key={ch.uuid}>
                        <a href={`/account/switcher/${ch.uuid}`}>{ch.basics?.title || ch.slug}</a>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
